import { useEffect, useState } from "react";
import axios from "axios";
const isDev =
Boolean(process.env.REACT_APP_IS_DEV_MODE) || false;
export const useGetPeFourToken = () => {
  const [fourToken, setFourToken] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://${isDev ? 'dev' : 'api'}.bc.army/api/show_in_homepage`)
      .then(function (response) {
        // handle success
        setFourToken(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, []);
  return { fourToken, loading };
};
